<template>
  <div class="menu-content">
    <transition name="fade">
      <div class="menu-list" v-if="listShow" :class="{ 'ui-hide': !uiToggleVar }">
        <ul class="menu-ul" @mouseenter="gzw_df=null;">
          <li v-for="(item, index) in menuData" :class="{
              hasChild: item.children,
              active: sceneIndex.first == item.active,
          }" class="menu-item" :key="index" @click="jumpScene(item);ppsj = index==4?true:false" @mouseenter="gzw_df=null">
<!--            <i class="icon" :class="`icon-${item.icon}`"></i>-->
            {{ item.lable }}
            <ul class="menu-child-ul" v-if="index == 0" >
              <li class="menu-child-li" :class="{
                active:
                  sceneIndex.first == item.active &&
                  sceneIndex.second == childItem.active,
              }" v-for="(childItem, childIndex) in item.children" :key="childIndex" @click="jumpScene(childItem)"
                :title="childItem.lable">
                {{ childItem.lable }}
              </li>
            </ul>
              <el-row class="menu-child-ul2" v-if="index == 1">
                  <el-col :span="6" v-for="(childItem, childIndex) in item.children" :key="childIndex"
                          class="menu-child-col">
                    <span class="menu-child-li2" :class="{
                      active:
                        sceneIndex.first == item.active &&
                        sceneIndex.second == secChildItem.active,
                    }" @click="jumpScene(secChildItem);tp(secChildItem,index)" :title="secChildItem.lable"
                          v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
                      {{ secChildItem.lable }}
                    </span>
                  </el-col>
              </el-row>
            <!-- 地方展区 -->
            <el-row class="menu-child-ul3" :class="gzw_df == 0 || gzw_df == 1 ? 'menu-child-ul3-noborder':''" 
            v-if="index == 2">
              <el-col :span="24" v-for="(childItem, childIndex) in item.children" :key="childIndex"
                class="menu-child-col">
                <span class="menu-child-li3" @mouseenter="gzw_df=secChildIndex"
                :class="{
                  active:
                    sceneIndex.first == item.active &&
                    sceneIndex.second == secChildItem.active,
                }" @click="jumpScene(secChildItem);" :title="secChildItem.lable"
                  v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
                  {{ secChildItem.lable }}
                </span>
              </el-col>
            </el-row>
            <el-row class="menu-child-ul3 menu-child-ul4" v-if="index == 2 && gzw_df == 0" @mouseenter="gzw_df=0">
              <el-col :span="6" v-for="(childItem, childIndex) in item.grandson1" :key="childIndex"
                class="menu-child-col">
                <span class="menu-child-li4" :class="{
                  active:
                    sceneIndex.first == item.active &&
                    sceneIndex.second == secChildItem.active,
                }" @click="jumpScene(secChildItem)" :title="secChildItem.lable"
                  v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
                  {{ secChildItem.lable }}
                </span>
              </el-col>
            </el-row>
            <el-row class="menu-child-ul3 menu-child-ul5" v-if="index == 2 && gzw_df == 1" @mouseenter="gzw_df=0">
              <el-scrollbar>
              <el-col :span="6" v-for="(childItem, childIndex) in item.grandson2" :key="childIndex"
                class="menu-child-col">
                <span class="menu-child-li4" :class="{
                  active:
                    sceneIndex.first == item.active &&
                    sceneIndex.second == secChildItem.active,
                }" @click="jumpScene(secChildItem)" :title="secChildItem.lable"
                  v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
                  {{ secChildItem.lable }}
                </span>
              </el-col>
            </el-scrollbar>
            </el-row> 
            <!-- 专题展区 -->
            <el-row class="menu-child-ul3 menu-child-ul6" :class="gzw_df == 0 || gzw_df == 1 ? 'menu-child-ul3-noborder':''" 
            v-if="index == 3">
              <el-col :span="24" v-for="(childItem, childIndex) in item.children" :key="childIndex"
                class="menu-child-col">
                <span class="menu-child-li3" @mouseenter="gzw_df=secChildIndex"
                :class="{
                  active:
                    sceneIndex.first == item.active &&
                    sceneIndex.second == secChildItem.active,
                }" @click="jumpScene(secChildItem)" :title="secChildItem.lable"
                  v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
                  {{ secChildItem.lable }}
                </span>
              </el-col>
            </el-row>
            <el-row class="menu-child-ul3 menu-child-ul7" v-if="index == 3 && gzw_df == 0" @mouseenter="gzw_df=0">
              <el-col :span="24" v-for="(childItem, childIndex) in item.grandson1" :key="childIndex"
                class="menu-child-col">
                <span class="menu-child-li4" :class="{
                  active:
                    sceneIndex.first == item.active &&
                    sceneIndex.second == secChildItem.active,
                }" @click="jumpScene(secChildItem)" :title="secChildItem.lable"
                  v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
                  {{ secChildItem.lable }}
                </span>
              </el-col>
            </el-row>
            <el-row class="menu-child-ul3 menu-child-ul8" v-if="index == 3 && gzw_df == 1" @mouseenter="gzw_df=0">
              <el-col :span="24" v-for="(childItem, childIndex) in item.grandson2" :key="childIndex"
                class="menu-child-col">
                <span class="menu-child-li4" :class="{
                  active:
                    sceneIndex.first == item.active &&
                    sceneIndex.second == secChildItem.active,
                }" @click="jumpScene(secChildItem)" :title="secChildItem.lable"
                  v-for="(secChildItem, secChildIndex) in childItem" :key="`${childIndex}-${secChildIndex}`">
                  {{ secChildItem.lable }}
                </span>
              </el-col>
            </el-row> 
          </li>
        </ul>

        <!-- <div class="menu-up" @click="listShow = false"></div> -->
      </div>
    </transition>

    <div class="menu-icon" @click="toggleMenu" :class="{ 'ui-hide': !uiToggleVar }"></div>
    <!-- 品牌市集 -->
    <div class="menuppsj-box" v-if="ppsj">
        <div class="menuppsj-bg" @click="ppsj=false"></div>
        <div class="menuppsj">
          <div class="menuppsj-close" @click="ppsj=false"></div>
          <el-scrollbar class="menuppsj-inner">
            <div class="menuppsj-img" v-for="(e, i) in ppsjI" :key="i+'ppsj'" :class="'ppsj_'+e"></div>
          </el-scrollbar>
        </div>
      </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { giveThumbsUp, cityInfo, gzwInfo, dfInfo } from "@/utils/tools.js";
import { grandson2} from "@/utils/toolsMenu.js";

export default {
  props: {
    krpano: "",
    uiToggleVar: true,
    sceneName: "",
  },
  computed: {
    sceneIndex() {
      if (this.sceneName) {
        var nowSceneName = this.sceneName.split("_");
        // console.error('nowSceneName = , nowSceneName', this.sceneName);

        return {
          first:
            nowSceneName[1] == 0
              ? nowSceneName[2] == 0
                ? 0
                : "0.5"
              : nowSceneName[1],
          second: nowSceneName[2],
        };
      } else {
        return {
          first: 0,
          second: "",
        };
      }
    },
  },
  data() {
    return {
      // krpano:"",
      gzw_df:null,
      ppsj:false,
      ppsjI:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
      menuData: [
        {
          lable: "序厅",
          index: "",
          disableClick: true,
          active: "0.5",
          // icon: "huangguan"
            children: [
                {
                    lable: "序言",
                    index: "0_1_1",
                    active: "1",
                },
                {
                    lable: "第一单元\u3000领航",
                    index: "0_2_1",
                    active: "2",
                },
                {
                    lable: "第二单元\u3000部门建品牌",
                    index: "0_3_1",
                    active: "3",
                },
                {
                    lable: "第三单元\u3000地方育品牌",
                    index: "0_4_1",
                    active: "4",
                },
                {
                    lable: "第四单元\u3000媒体推品牌",
                    index: "0_5_1",
                    active: "5",
                },
                {
                    lable: "第五单元\u3000我们和品牌",
                    index: "0_6_1",
                    active: "6",
                },
                {
                    lable: "第六单元\u3000创意与品牌",
                    index: "0_7_1",
                    active: "7",
                },
                {
                    lable: "第七单元\u3000世界看品牌",
                    index: "0_8_1",
                    active: "8",
                }
            ]
        },
        {
          lable: "地方展区",
          index: "",
          disableClick: true,
          active: "1",
          // icon: "circle",
            children: [[
        {
            "lable": "北京",
            "active": "",
            "disableClick": true,
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690877687013376"
        },
        {
            "lable": "天津",
            "active": "2",
            "disableClick": true,
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690877972226048"
        },
        {
            "lable": "河北",
            "active": "3",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878156775424"
        },
        {
            "lable": "山西",
            "active": "4",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878341324800"
        },
        {
            "lable": "内蒙古",
            "active": "5",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878500708352"
        },
        {
            "lable": "辽宁",
            "active": "6",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878668480512"
        },
        {
            "lable": "吉林",
            "active": "7",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690878853029888"
        },
        {
            "lable": "黑龙江",
            "active": "8",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879004024832"
        },
        {
            "lable": "上海",
            "active": "9",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879180185600"
        },
        {
            "lable": "浙江",
            "active": "10",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879532507136"
        },
    ],
    [
        {
            "lable": "江苏",
            "active": "11",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879356346368"
        },
        {
            "lable": "安徽",
            "active": "12",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879708667904"
        },
        {
            "lable": "福建",
            "active": "13",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690879876440064"
        },
        {
            "lable": "江西",
            "active": "14",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880052600832"
        },
        {
            "lable": "山东",
            "active": "15",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880211984384"
        },
        {
            "lable": "河南",
            "active": "16",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880371367936"
        },
        {
            "lable": "湖北",
            "active": "17",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880564305920"
        },
        {
            "lable": "湖南",
            "active": "18",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880732078080"
        },
        {
            "lable": "广东",
            "active": "19",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690880899850240"
        },
        {
            "lable": "广西",
            "active": "20",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881050845184"
        },
    ],
    [
        {
            "lable": "海南",
            "active": "21",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881277337600"
        },
        {
            "lable": "重庆",
            "active": "22",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881445109760"
        },
        {
            "lable": "四川",
            "active": "23",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881587716096"
        },
        {
            "lable": "贵州",
            "active": "24",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881755488256"
        },
        {
            "lable": "云南",
            "active": "25",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690881931649024"
        },
        {
            "lable": "西藏",
            "active": "26",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690882099421184"
        },
        {
            "lable": "陕西",
            "active": "27",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690882267193344"
        },
        {
            "lable": "甘肃",
            "active": "28",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690882602737664"
        },
        {
            "lable": "青海",
            "active": "29",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690882443354112"
        },
        {
            "lable": "宁夏",
            "active": "30",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2690774000447004672"
        },
    ],
    [
        {
            "lable": "新疆",
            "active": "31",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690883223494656"
        },
        {
            "lable": "兵团",
            "active": "32",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2690761190975479808"
        },
        {
            "lable": "深圳",
            "active": "33",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690884255293440"
        },
        {
            "lable": "青岛",
            "active": "34",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690883575816192"
        },
        {
            "lable": "宁波",
            "active": "35",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690883877806080"
        },
        {
            "lable": "大连",
            "active": "36",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690883391266816"
        },
        {
            "lable": "厦门",
            "active": "37",
            "isLink": true,
            "href": "https://wangzhan.cctv.com/2024ppr/local/index.shtml?exhibitionId=2674690884053966848"
        }
    ]
],
        },
        {
          lable: "企业展区",
          index: "",
          disableClick: true,
          active: "2",
          // icon: "house",
          children: [
            [{
                lable: "国\u0020资\u0020委\u0020推\u0020荐\u0020企\u0020业",
                
                active: "11",
            },
            {
                lable: "地\u0020方\u0020推\u0020荐\u0020企\u0020业",
                
                active: "11",
            }],
          ],
          grandson1:[
  [
    {
      "lable": "中核集团",
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692423447420928"
    },
    {
      "lable": "航天科技",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692423631970304"
    },
    {
      "lable": "航空工业集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692423816519680"
    },
    {
      "lable": "中国航发",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424009457664"
    },
    {
      "lable": "中国石油",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424185618432"
    },
    {
      "lable": "中国石化",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424395333632"
    },
    {
      "lable": "中国海油",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424588271616"
    },
    {
      "lable": "国家电网",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2687714133700255744"
    },
    {
      "lable": "南方电网",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424764432384"
    },
    {
      "lable": "中国华能",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2687214108171837440"
    },
    {
      "lable": "中国华电",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692424957370368"
    },
    {
      "lable": "国家电投",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425158696960"
    },
    {
      "lable": "中国三峡集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425368412160"
    }
  ],
  [
    {
      "lable": "国家能源集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425561350144"
    },
    {
      "lable": "中国电信",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425754288128"
    },
    {
      "lable": "中国联通",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692425947226112"
    },
    {
      "lable": "中国移动",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692426140164096"
    },
    {
      "lable": "中国电子",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2690727242773831680"
    },
    {
      "lable": "中国一汽",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692426526040064"
    },
    {
      "lable": "东风公司",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692426727366656"
    },
    {
      "lable": "中国一重",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692426937081856"
    },
    {
      "lable": "国机集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427130019840"
    },
    {
      "lable": "东方电气集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427339735040"
    },
    {
      "lable": "鞍钢",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427549450240"
    },
    {
      "lable": "中铝集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427775942656"
    },
    {
      "lable": "中国远洋",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2687714134765608960"
    }
  ],
  [
    {
      "lable": "中航集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692427985657856"
    },
    {
      "lable": "中国东航",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428354756608"
    },
    {
      "lable": "南航集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428161818624"
    },
    {
      "lable": "中国五矿",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428572860416"
    },
    {
      "lable": "通用技术集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428757409792"
    },
    {
      "lable": "中国建筑",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692428933570560"
    },
    {
      "lable": "中国南水北调",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692429344612352"
    },
    {
      "lable": "中国旅游集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692429772431360"
    },
    {
      "lable": "中国商飞",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692429982146560"
    },
    {
      "lable": "中煤集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692430368022528"
    },
    {
      "lable": "中国煤炭科工",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692430577737728"
    },
    {
      "lable": "中国建材",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2693692384562126848"
    },
    {
      "lable": "中国有色",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2687714135470252032"
    }
  ],
  [
    {
      "lable": "中国中车集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692431164940288"
    },
    {
      "lable": "中国中铁",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692431617925120"
    },
    {
      "lable": "中国铁建",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692431810863104"
    },
    {
      "lable": "中交集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692431987023872"
    },
    {
      "lable": "保利集团",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692432372899840"
    },
    {
      "lable": "中煤地质总局",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692432565837824"
    },
    {
      "lable": "中国航信",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692432750387200"
    },
    {
      "lable": "中国航油",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692432934936576"
    },
    {
      "lable": "中国电建",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692433111097344"
    },
    {
      "lable": "中广核",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692433664745472"
    },
    {
      "lable": "中国电气装备",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692433866072064"
    },
    {
      "lable": "中国绿发",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692434050621440"
    },
    {
      "lable": "中国铁塔",
      
      "active": "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/Company/index.shtml?exhibitionId=2674690886478274560&cid=2674692434243559424"
    }
  ]
],
          grandson2:grandson2
        },
        {
          lable: "专题展区",
          index: "",
          active: "3",
          disableClick:true,
          // icon: "future"
          children: [
            [{
                lable: "美\u0020好\u0020之\u0020城",
                active: "11",
            },
            {
                lable: "和\u0020合\u0020共\u0020创",
                active: "11",
            }]
          ],
          grandson1:[
            [{
                  lable: "鄂尔多斯",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885689745408"
              },
              {
                  lable: "延边",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885194817536"
              },
              {
                  lable: "苏州",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690884616003584"
              },
              {
                  lable: "景德镇",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885362589696"
              },
              {
                  lable: "中山",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885010268160"
              },
              {
                  lable: "眉山",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690884800552960"
              },
              {
                  lable: "榆林",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2674690885530361856"
              }
            ]
          ],
          grandson2:[
            [{
                  lable: "施工企业管理协会",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2687744855517437952"
              },
              {
                  lable: "自行车协会",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2687744855542603776"
              },
              {
                  lable: "注册会计师协会",
                  
                  active: "11",
      "isLink": true,
      "href": "https://wangzhan.cctv.com/2024ppr/special/index.shtml?exhibitionId=2687744855567769600"
              }
            ],
          ]
        },
        {
          lable: "品牌市集",
          index: "",
          active: "3",
          disableClick:true,
          // icon: "future"
        },
        {
          lable: "中国品牌日官网",
          index: "",
          active: "3",
          disableClick:true,
          isBlank: true,
          isLink: true,
          href: "https://www.cibexpo.org.cn"
        },
        {
          lable: "中国品牌消费系列活动",
          index: "",
          active: "3",
          disableClick:true,
          isBlank: true,
          isLink: true,
          href: "https://culture-travel.cctv.com/special/2024ppxf/index.shtml"
        },
      ],
      listShow: false,
      cityList: [
        [

        ]
      ]
    };
  },
  methods: {
    ...mapMutations('common', ['SET_CLICKED_MAPLIST','SET_TP']),
    tp(item,index){
      if(index==1){
        let city = cityInfo.filter(i => i.name == item.lable)[0]
        giveThumbsUp(16020, city.groupId, city.id)
      }else if(index==2){
        let gzw = gzwInfo.filter(i => i.name == item.lable)[0]
        giveThumbsUp(16020, gzw.groupId, gzw.id)
      }else if(index==3){
          let df = dfInfo.filter(i => i.name == item.name)[0]
          giveThumbsUp(16020, df.groupId, df.id)
      }
    },
    toggleMenu() {
      this['SET_TP'](false);
      this.listShow = !this.listShow;
    },
    jumpScene(item) {
      window.goldlog.record("/spec.1.1", "", "snsScene=导览页&product=pcweb&pagename=云上2024年品博会", "");
      window.goldlog.record("/spec.1.1", "", "snsScene="+item.lable+"&product=pcweb&pagename=云上2024年中国品牌博览会", "");
        if (item.isLink) {
          if(item.isBlank){
            window.open(item.href)
          }else{
            window.open(item.href,'_self')
          }
          return
        }
        if (item.disableClick) {
          if (item.handleEmit) {
            this.$emit(item.handleEmit)
          } else {
          }
          return
        }
      if (!item.disableClick) {
        // 数据插入clickedMapList
        this['SET_CLICKED_MAPLIST'](`scene_${item.index}`)
        this.krpano.call(
          "loadscene(" +
          `scene_${item.index}` +
          ",null, MERGE, OPENBLEND(1.0, -0.5, 0.3, 0.8, linear));"
        );
      }
    },
  },
  mounted() {
    // this.krpano = document.getElementById("krpanoSWFObject");
  },
  created() { },
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.menu-icon {
  width: 248px;
  height: 77px;
  position: absolute;
  top: 58px;
  left: 50px;
  cursor: pointer;
  background-image: url("../assets/img/menu-icon.png");
  @include background-com();
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  opacity: 1;

  &.ui-hide {
    transform: translateX(-5rem);
    opacity: 0;
  }
}

.menu-list {
  width: 300px;
  height: 278px;
  position: absolute;
  top: 150px;
  left: 50px;
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  opacity: 1;

  &.ui-hide {
    transform: translateX(-5rem);
    opacity: 0;
  }

  @media screen and (max-width: 1380px) {
    & {
      // width: 4.2rem;
    }
  }

  .menu-ul {
    width: 100%;
    background-color: rgba($color: #000000, $alpha: 0.82);
    border-radius: 18px;
    padding: 18px 0;


    .menu-item {
      width: 100%;
      height: 61px;
      padding: 0 30px;
      text-align: left;
      color: #ffffff;
      font-size: 22px;
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;
      justify-items: flex-start;
      font-weight: 700;

      li, span, ul{
        font-weight: 400;
      }

      &.hasChild::after {
        content: "";
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #ffffff;
        vertical-align: middle;
        display: inline-block;
        position: absolute;
        right: 30px;
        top: 50%;
        margin-top: -5px;
      }

      .icon {
        width: 18px;
        height: 21px;
        @include background-com();
        display: inline-block;
        margin-right: 10px;

        &.icon-building {
          background-image: url("../assets/img/icon-building.png");
        }

        &.icon-huangguan {
          background-image: url("../assets/img/icon-huangguan.png");
        }

        &.icon-circle {
          background-image: url("../assets/img/icon-circle.png");
        }

        &.icon-house {
          background-image: url("../assets/img/icon-house.png");
        }

        &.icon-future {
          background-image: url("../assets/img/icon-future.png");
        }
        &.icon-hudong {
          background-image: url("../assets/img/icon-hudong.png");
        }
      }

      &:hover {
        background-color: #444444;
        color: #df8903;

        .menu-child-ul {
          display: block;
        }

        .menu-child-ul2 {
          display: block;
        }

          .menu-child-ul3 {
              display: block;
          }

        .icon {

          &.icon-building {
            background-image: url("../assets/img/icon-building-active.png");
          }

          &.icon-huangguan {
            background-image: url("../assets/img/icon-huangguan-active.png");
          }

          &.icon-circle {
            background-image: url("../assets/img/icon-circle-active.png");
          }

          &.icon-house {
            background-image: url("../assets/img/icon-house-active.png");
          }

          &.icon-future {
            background-image: url("../assets/img/icon-future-active.png");
          }
          &.icon-hudong {
          background-image: url("../assets/img/icon-hudong-active.png");
        }
        }
      }

      &.active {
        color: #df8903;

        .icon {

          &.icon-building {
            background-image: url("../assets/img/icon-building-active.png");
          }

          &.icon-huangguan {
            background-image: url("../assets/img/icon-huangguan-active.png");
          }

          &.icon-circle {
            background-image: url("../assets/img/icon-circle-active.png");
          }

          &.icon-house {
            background-image: url("../assets/img/icon-house-active.png");
          }

          &.icon-future {
            background-image: url("../assets/img/icon-future-active.png");
          }
          &.icon-hudong {
          background-image: url("../assets/img/icon-hudong-active.png");
        }
        }
      }

      .menu-child-ul {
        width: 280px;
        // height: 550px;
        position: absolute;
        display: none;
        overflow: hidden;
        top: 0;
        left: 100%;
        padding-top: 28px;
        padding-bottom: 28px;
        background-color: rgba($color: #212121, $alpha: 0.92);
        border-top-right-radius: 28px;
        border-bottom-right-radius: 28px;
        //border-bottom-left-radius: 28px;
        z-index: 10000;

        .menu-child-li {
          width: 100%;
          padding: 0 28px;
          height: 45px;
          line-height: 45px;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          font-size: 20px;
          text-align: left;

          &:hover {
            background-color: #444444;

          }

          &.active {
            color: #df8903;
          }
        }


      }

      .menu-child-ul2 {
        width: 460px;
        min-height: 420px;
        position: absolute;
        display: none;
        overflow: hidden;
        top: 0;
        left: 100%;
        padding-top: 28px;
        padding-bottom: 28px;
        background-color: rgba($color: #212121, $alpha: 0.92);
        border-top-right-radius: 28px;
        border-bottom-right-radius: 28px;
        border-bottom-left-radius: 28px;
        z-index: 10000;

        .menu-child-col {
          position: relative;

          &::after {
            width: 2px;
            display: block;
            background-color: #ffffff;
            height: 100%;
            content: "";
            position: absolute;
            right: 0;
            top: 0;
          }

          &:last-child {
            &::after {
              display: none;
            }
          }

          .menu-child-li2:last-child {
            margin-bottom: 0;
          }
        }

        .menu-child-li2 {
          width: 100%;
          padding: 0 25px;
   
          display: inline-block;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          font-size: 20px;
          text-align: justify;
          text-justify: distribute-all-lines;
          text-align-last: justify;
          margin-bottom: 16px;
          vertical-align: top;

          &:hover {
            background-color: #444444;

          }

          &.active {
            color: #df8903;
          }
        }
      }

        // .menu-child-ul3 {
        //     width: 300px;
        //     min-height: 120px;
        //     position: absolute;
        //     display: none;
        //     overflow: hidden;
        //     top: 0;
        //     left: 100%;
        //     padding-top: 28px;
        //     padding-bottom: 28px;
        //     background-color: rgba($color: #212121, $alpha: 0.92);
        //     border-top-right-radius: 28px;
        //     border-bottom-right-radius: 28px;
        //     //border-bottom-left-radius: 28px;
        //     z-index: 10000;

        //     .menu-child-col {
        //         position: relative;

        //         &::after {
        //             width: 2px;
        //             display: block;
        //             background-color: #ffffff;
        //             height: 100%;
        //             content: "";
        //             position: absolute;
        //             right: 0;
        //             top: 0;
        //         }

        //         &:last-child {
        //             &::after {
        //                 display: none;
        //             }
        //         }

        //         .menu-child-li3:last-child {
        //             margin-bottom: 0;
        //         }
        //     }

        //     .menu-child-li3 {
        //         width: 100%;
        //         padding: 0 25px;

        //         display: inline-block;
        //         color: #ffffff;
        //         white-space: nowrap;
        //         overflow: hidden;
        //         font-size: 20px;
        //         text-align: justify;
        //         text-justify: distribute-all-lines;
        //         text-align-last: justify;
        //         margin-bottom: 16px;
        //         vertical-align: top;

        //         &:hover {
        //             background-color: #444444;

        //         }

        //         &.active {
        //             color: #df8903;
        //         }
        //     }
        // }
        
        .menu-child-ul3 {
            width: 279px;
            min-height: 120px;
            position: absolute;
            display: none;
            overflow: hidden;
            top: 0;
            left: 100%;
            padding-top: 28px;
            padding-bottom: 28px;
            background-color: rgba($color: #212121, $alpha: 0.92);
            border-top-right-radius: 28px;
            border-bottom-right-radius: 28px;
            //border-bottom-left-radius: 28px;
            z-index: 10000;

            .menu-child-col {
                position: relative;

                &::after {
                    width: 2px;
                    display: block;
                    background-color: #ffffff;
                    height: 100%;
                    content: "";
                    position: absolute;
                    right: 0;
                    top: 0;
                }

                &:last-child {
                    &::after {
                        display: none;
                    }
                }

                .menu-child-li3:last-child {
                    margin-bottom: 0;
                }
            }

            .menu-child-li3 {
                width: 100%;
                padding: 0 25px;

                display: inline-block;
                color: #ffffff;
                white-space: nowrap;
                overflow: hidden;
                font-size: 20px;
                // text-align: justify;
                // text-justify: distribute-all-lines;
                // text-align-last: justify;
                margin-bottom: 16px;
                vertical-align: top;

                text-align: left;

                

                &:hover {
                    background-color: #444444;

                }

                &.active {
                    color: #df8903;
                }

                &::after {
                  content: "";
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background-color: #ffffff;
                  vertical-align: middle;
                  display: inline-block;
                  position: absolute;
                  right: 30px;
                  // top: 0;
                  margin-top: 9px;
              }
            }
        }
        .menu-child-ul3-noborder{
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
        .menu-child-li4 {
          width: 100%;
          padding: 0 25px;
          display: inline-block;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          font-size: 20px;
          text-align: justify;
          text-justify: distribute-all-lines;
          text-align-last: justify;
          margin-bottom: 16px;
          vertical-align: top;
          &:hover {
              background-color: #444444;

          }

          &.active {
              color: #df8903;
          }
        }
        .menu-child-ul4{
          width: 700px;
          left: 193%;
          border-bottom-left-radius: 28px;
          padding-bottom: 12px;
        }
        .menu-child-ul5{
          width: 900px;
          left: 193%;
          border-bottom-left-radius: 28px;
          padding-bottom: 12px;
          height: 610px;
          overflow-x: hidden;
        }
        .menu-child-ul6{
          width: 210px;
          // min-height: 120px;
        }
        .menu-child-ul7{
          padding-bottom: 12px;
          left: 170%;
          border-bottom-left-radius: 28px;

          width: 140px;
          // min-height: 320px;
        }
        .menu-child-ul8{
          padding-bottom: 12px;
          left: 170%;
          border-bottom-left-radius: 28px;

          width: 200px;

        }
    }

    // .menu-up {
    //   width: 0.3rem;
    //   height: 0.14rem;
    //   background-image: url("../assets/img/menu-up.png");
    //   @include background-com();
    //   position: absolute;
    //   left: 50%;
    //   margin-left: -0.15rem;
    //   bottom: 0.3rem;
    //   cursor: pointer;
    //   &:hover {
    //     background-image: url("../assets/img/menu-up-hover.png");
    //   }
    // }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.menuppsj-box {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;

  .menuppsj-bg {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.6);
  }

  .menuppsj-close {
    position: absolute;
    right: 12px;
    top: 10px;
    width: 40px;
    height: 40px;
    // background: url("../assets/img/close-btn.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    z-index: 100;
  }

  .menuppsj {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // width: 400px;
    // height: 500px;
    // width: 4rem;
    // height: 5rem;
    width: 1360px;
    height: 580px;
    position: absolute;
    // background-color: #fff;
    background-image: url(../assets/img/daolan/ppsj_bg.jpg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    // border-radius: 0.2rem;
    border-radius: 8px;
    // padding-top: 0.85rem;
    padding-top: 4.1%;
    box-sizing: border-box;
    text-align: center;

    .menuppsj-inner{
      width: 100%;
      height: 83.3%;
      position: absolute;
      //background-color: #fff;
      box-sizing: border-box;
      // overflow: hidden;
      // overflow-y: auto;
      // overflow-x: hidden;
    }

    .menuppsj-img {
      //top: 4%;
      left: 2%;
      width: 96%;
      height: 5rem;
      position: relative;
      // background-image: url(../assets/img/daolan/ppsj_img.jpg);
      @include background-com();
    }
    .ppsj_1{
    background-image: url(../assets/img/daolan/ppsj/01.png);
    }
    .ppsj_2{
      background-image: url(../assets/img/daolan/ppsj/02.png);
    }
    .ppsj_3{
      background-image: url(../assets/img/daolan/ppsj/03.png);
    }
    .ppsj_4{
      background-image: url(../assets/img/daolan/ppsj/04.png);
    }
    .ppsj_5{
      background-image: url(../assets/img/daolan/ppsj/05.png);
    }
    .ppsj_6{
      background-image: url(../assets/img/daolan/ppsj/06.png);
    } 
    .ppsj_7{
      background-image: url(../assets/img/daolan/ppsj/07.png);
    }
    .ppsj_8{
      background-image: url(../assets/img/daolan/ppsj/08.png);
    }
    .ppsj_9{
      background-image: url(../assets/img/daolan/ppsj/09.png);
    } 
    .ppsj_10{
      background-image: url(../assets/img/daolan/ppsj/10.png);
    }  
    .ppsj_11{
      background-image: url(../assets/img/daolan/ppsj/11.png);
    }
    .ppsj_12{
      background-image: url(../assets/img/daolan/ppsj/12.png);
    }
    .ppsj_13{
      background-image: url(../assets/img/daolan/ppsj/13.png);
    }
    .ppsj_14{
      background-image: url(../assets/img/daolan/ppsj/14.png);
    }
    .ppsj_15{
      background-image: url(../assets/img/daolan/ppsj/15.png);
    }

    .ppsj_16{
      background-image: url(../assets/img/daolan/ppsj/16.png);
    }  
    .ppsj_17{
      background-image: url(../assets/img/daolan/ppsj/17.png);
    }
  }
}
</style>

<style lang="scss">
.el-scrollbar {
  height: 100%;
}

.menu-child-ul5, .menuppsj{

  .el-scrollbar__bar {
      &.is-vertical {
        width: 0.15rem; //滚动条宽度
        background-color: #c7c7c7;
      }
    }

  .el-scrollbar__wrap {
      overflow-y: auto;
      overflow-x: hidden;
    }

  .el-scrollbar__thumb {
      ////可设置滚动条颜色
      background-image: url("../assets/img/scroll-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

}

</style>

